/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class ProducttagsDialog extends NoboxEntityDialog<ProducttagsRow, any> {
        protected getFormKey() { return ProducttagsForm.formKey; }
        protected getIdProperty() { return ProducttagsRow.idProperty; }
        protected getLocalTextPrefix() { return ProducttagsRow.localTextPrefix; }
        protected getNameProperty() { return ProducttagsRow.nameProperty; }
        protected getService() { return ProducttagsService.baseUrl; }
        protected getDeletePermission() { return ProducttagsRow.deletePermission; }
        protected getInsertPermission() { return ProducttagsRow.insertPermission; }
        protected getUpdatePermission() { return ProducttagsRow.updatePermission; }

        protected form = new ProducttagsForm(this.idPrefix);

        constructor(container: JQuery) {
            super(container);
            this.element.children("div.panel-titlebar").css("justify-content", "space-between");
            this.element.children("div.panel-titlebar").append(`<a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="https://crm.nobox.ai/knowledge-base/article/setting">
                    <div class="tool-button icon-tool-button" title="Help">
                        <div class="button-outer">
                            <span class="button-inner green">
                                <i class="fa fa-question-circle text-blue"></i>
                            </span>
                        </div>
                    </div>
                </a>`);
        }
    }
}